module.exports = __webpack_public_path__ + "static/media/building.00b4e59e.jpg";